<script setup>
import { ref } from "vue";
import BrandInput from "@/Components/Brand/BrandInput.vue";

defineOptions({
    inheritAttrs: false,
});

defineProps({
    modelValue: String,
    id: String,
});

defineEmits(["update:modelValue"]);

const showPassword = ref(false);
</script>

<template>
    <div class="relative flex items-center">
        <BrandInput
            :id="id"
            :model-value="modelValue"
            :type="showPassword ? 'text' : 'password'"
            class="pr-11"
            v-bind="$attrs"
            @update:model-value="$emit('update:modelValue', $event)"
        />
        <button
            type="button"
            class="absolute right-3 flex items-center justify-center border-0 bg-transparent p-1 text-[#a79e9b] transition-colors hover:text-[#3c3938]"
            @click="showPassword = !showPassword"
            :aria-label="showPassword ? 'Hide password' : 'Show password'"
            tabindex="-1"
        >
            <!-- Eye icon (show) -->
            <svg
                v-if="!showPassword"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="size-5"
            >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
            </svg>
            <!-- Eye-off icon (hide) -->
            <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="size-5"
            >
                <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                />
                <line x1="1" y1="1" x2="23" y2="23" />
            </svg>
        </button>
    </div>
</template>
